var EventAggregator = (function () {
    function EventAggregator() {
        this.events = {};
        this.seed = 0;
    }
    EventAggregator.prototype.publish = function (event, data, eventName) {
        if (this.events[event]) {
            for (var _i = 0, _a = this.events[event]; _i < _a.length; _i++) {
                var subscriber = _a[_i];
                eventName ? subscriber.lambda({ data: data, eventName: eventName }) : subscriber.lambda(data);
            }
        }
    };
    EventAggregator.prototype.subscribe = function (event, lambda) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        ++this.seed;
        var token = (this.seed).toString();
        this.events[event].push({ lambda: lambda, token: token });
        return token;
    };
    EventAggregator.prototype.unSubscribe = function (token) {
        for (var event_1 in this.events) {
            if (this.events.hasOwnProperty(event_1)) {
                var mySubscribes = this.events[event_1];
                for (var index = 0; index < mySubscribes.length; index++) {
                    if (mySubscribes[index].token === token) {
                        mySubscribes.splice(index, 1);
                        return token;
                    }
                }
            }
        }
        return false;
    };
    return EventAggregator;
}());
export { EventAggregator };
